import { render, staticRenderFns } from "./CustomCommands.vue?vue&type=template&id=4bc8f5bc"
import script from "./CustomCommands.vue?vue&type=script&lang=js"
export * from "./CustomCommands.vue?vue&type=script&lang=js"
import style0 from "./CustomCommands.vue?vue&type=style&index=0&id=4bc8f5bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports